<template>
  <div class="addexpress">
    <div class="myspespace"></div>
    <div class="con">
      <div class="sendget send" @click="jumpList('send')">
        <div class="left">
          <div class="round">寄</div>
        </div>
        <div class="center">
          <div class="title">{{send.username}} {{send.telephone}}</div>
          <div class="address">{{send.province}}{{send.city}}{{send.county}} {{send.adrdetail}}</div>
        </div>
        <div class="right"><van-icon class="arrow" name="arrow" /></div>
      </div>
      <div class="sendget get" @click="jumpList('get')">
        <div class="left">
          <div class="round">收</div>
        </div>
        <div class="center">
          <div class="title">{{get.username}} {{get.telephone}}</div>
          <div class="address">{{get.province}}{{get.city}}{{get.county}} {{get.adrdetail}}</div>
        </div>
        <div class="right"><van-icon class="arrow" name="arrow" /></div>
      </div>
      <div>
        <van-form>
          <van-field
            class="myvanfield"
            label=""
            placeholder="请输入快递类型"
            disabled
            value="顺丰标快"
          >
            <template v-slot:label>
              <div>快递类型<span class="red">（必填）</span></div>
            </template>
          </van-field>
          <van-field
            class="myvanfield"
            v-model="subdata.depositnumNo"
            type="digit"
            label="托寄物数量"
            placeholder="件"
          >
            <template v-slot:label>
              <div>托寄物数量<span class="red">（必填）</span></div>
            </template>
          </van-field>
          <van-field
            class="myvanfield"
            v-model="subdata.depositumInfo"
            label=""
            placeholder="可填写简称"
          >
            <template v-slot:label>
              <div>托寄物内容<span class="red">（必填）</span></div>
            </template>
          </van-field>
          <van-field
            class="myvanfield"
            label="付款方式"
            disabled
            placeholder="取件付"
            value="寄付现结"
          />
          <van-cell class="myvancell" :value="choosedcoupon.title" is-link @click="showCoupon">
            <!-- 使用 title 插槽来自定义标题 -->
            <template #title>
              <span class="custom-title">优惠券</span>
            </template>
          </van-cell>
          <van-cell class="myvancell" :value="subdata.sendStartTime ? subdata.sendStartTime : '取件时间'" is-link @click="getTimeSelect">
            <!-- 使用 title 插槽来自定义标题 -->
            <template #title>
              <span class="custom-title">上门取件时间</span>
            </template>
          </van-cell>
          <van-field
            class="myvanfield"
            v-model="subdata.remark"
            label="寄方备注"
            placeholder="请输入备注内容"
          />
        </van-form>
        <div class="des">请在快递员取件后，返回本平台完成费用支付！</div>
      </div>
    </div>
    <div v-if="not_pay_orders > 0" @click="jumpWaitPay" class="waitpay">您有待支付的订单，点击后可跳转支付页面</div>
    <footer2 ref="myfooter" @subOrder="subOrder"></footer2>
    <van-popup class="expresspopup" v-model="show" position="bottom" :style="{ height: '50%' }" >
      <div class="popcon">
        <div class="h1">
          <span class="myspan1">期望上门时间</span>
          <span @click="onConfirm">确定</span>
        </div>
        <div class="h2">供快递员参考的时间(非承诺)</div>
        <div class="timecon">
          <div class="left">
            <div class="item" :class="{'focus': item.focus}" v-for="(item ,index) in timeObj" :key="index" @click="chooseItem(item)">{{item.name}}</div>
          </div>
          <div class="right">
            <van-picker
              title=""
              ref="myvanpicker"
              show-toolbar
              :columns="columns"
            />
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup class="expresspopup" position="bottom" v-model="show2" :style="{ height: '70%' }">
      <div class="couponspecon">
        <mycoupons ref="mycoupons" :coupon="choosedcoupon" @subCoupon="subCoupon" ></mycoupons>
      </div>
    </van-popup>
  </div>
</template>

<script>
import footer2 from '../components/footer2'
import mycoupons from '../components/mycoupons'
import { addSf, checkPrice } from '@/api/modules/sf'
import { personalInfo, getUserCardList } from '@/api/modules/user'
import { Toast } from 'vant'
export default {
  name: 'addexpress',
  components: {
    footer2, mycoupons
  },
  watch: {
    'subdata.depositnumNo'(newValue) {
      if (newValue > 0) {
        this.checkPrice()
      }
    },
    send: {
      immediate: true,
      deep: true,
      handler: function(newValue) {
        if (newValue.telephone) {
          this.checkPrice()
        }
      }
    },
    get: {
      immediate: true,
      deep: true,
      handler: function(newValue) {
        if (newValue.telephone) {
          this.checkPrice()
        }
      }
    }
  },
  data() {
    return {
      show: false,
      show2: false,
      columns: [],
      searchOptions: {
        'status': '1',
        'company_id': '1',
        'scope_type': 'sf'
      },
      searchPage: {
        'page': 1,
        'pageSize': 10
      },
      nocoupon: false,
      choosedcoupon: {
        title: '',
        code: ''
      },
      not_pay_orders: -1,
      send:{
        province: '',
        city: '',
        county: '',
        address_id: '',
        adrdetail: '',
        username: '',
        telephone: ''
      },
      get: {
        province: '',
        city: '',
        county: '',
        address_id: '',
        adrdetail: '',
        username: '',
        telephone: ''
      },
      subdata: {
        coupon: '',
        jContact: '',
        jMobile: '',
        jProvince: '',
        jCity: '',
        dContact: '',
        dMobile: '',
        dProvince: '',
        dCity: '',
        depositumInfo: '文件',
        depositnumNo: 1,
        remark: '',
        sendStartTime: '',
        shipping_fee: ''
      },
      timeObj: []
    }
  },
  computed: {
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 从用户选择返回
      if (to.query.type === 'send') {
        vm.setSend(to.query)
      }
      if (to.query.type === 'get') {
        vm.setGet(to.query)
      }
      if (!to.query.type) {
        if (from.name !== 'addresslist') {
          vm.clearAll()
        }
      }
      vm.getPersonInfo()
    })
  },
  created() {
    this.setTime()
    this.loadCoupon()
    this.getPersonInfo()
  },
  methods: {
    loadCoupon() {
      const params = Object.assign({}, this.searchPage, this.searchOptions)
      getUserCardList(params).then((res) => {
        if (res.data && res.data.list && res.data.list.length > 0) {
          this.choosedcoupon = res.data.list[0].coupon
          console.log(this.choosedcoupon)
        }
        else {
          this.nocoupon = true
        }
      })
    },
    subCoupon(coupon) {
      this.choosedcoupon = coupon
      this.subdata.coupon = coupon.code
      this.show2 = false
    },
    showCoupon() {
      if (this.nocoupon === true) {
        Toast('您还没有优惠券')
      }
      else {
        this.show2 = true
      }
    },
    jumpWaitPay() {
      this.$router.push('/sf/waitpay')
    },
    getPersonInfo() {
      personalInfo().then((res) => {
        if (res.data.status_code === 200) {
          this.not_pay_orders = res.data.not_pay_orders
        }
      })
    },
    checkPrice() {
      this.subdata.jProvince = this.send.province
      this.subdata.jCity = this.send.city
      this.subdata.jAddress = this.send.adrdetail
      this.subdata.dProvince = this.get.province
      this.subdata.dAddress = this.get.adrdetail
      this.subdata.dCity = this.get.city
      if (this.subdata.jProvince && this.subdata.dProvince && this.subdata.depositnumNo > 0) {
        checkPrice({
          jProvince: this.subdata.jProvince,
          jCity: this.subdata.jCity,
          jAddress: this.subdata.jAddress,
          dProvince: this.subdata.dProvince,
          dAddress: this.subdata.dAddress,
          dCity: this.subdata.dCity
        }).then((res) => {
          console.log(res)
          if (res.data.succ === 'ok') {
            let price = parseInt(res.data.result.price.split('元')[0]) * parseInt(this.subdata.depositnumNo)
            this.subdata.shipping_fee = price
            this.$refs.myfooter.setPrice(price+' 元')
          }
        })
      }
    },
    onConfirm() {
      let val = this.$refs.myvanpicker.getValues()[0].split(' - ')[0]
      this.timeObj.forEach((item) => {
        if (item.focus === true) {
          this.subdata.sendStartTime = item.date + ' ' + val
        }
      })
      this.show = false
    },
    setTime() {
      let currentDate = new Date()
      let nextHour = currentDate.getHours() + 1
      let year = currentDate.getFullYear()
      let month = currentDate.getMonth()
      let date = currentDate.getDate()
      let yeartoday = new Date(year, month, date)
      let yeartom = new Date(yeartoday.getTime() + 24 * 60 * 60 * 1000)
      let yearsec = new Date(yeartoday.getTime() + 24 * 2 * 60 * 60 * 1000)
      let yearthird = new Date(yeartoday.getTime() + 24 * 3 * 60 * 60 * 1000)
      // 这里表示已经停止工作，需要到第二天
      if (nextHour >= 17) {
        this.timeObj = [
          {
            'name': '明天',
            'focus': true,
            'date': yeartom.getFullYear() + '-' + (yeartom.getMonth() <= 8 ? '0' + (yeartom.getMonth() + 1) : yeartom.getMonth() +1 ) + '-' + (yeartom.getDate() <= 9 ? '0' + yeartom.getDate() : yeartom.getDate()),
            'value': []
          },
          {
            'name': '后天',
            'focus': false,
            'date': yearsec.getFullYear() + '-' + (yearsec.getMonth() <= 8 ? '0' + (yearsec.getMonth() + 1) : yearsec.getMonth() +1 ) + '-' + (yearsec.getDate() <= 9 ? '0' + yearsec.getDate() : yearsec.getDate()),
            'value': []
          },
          {
            'name': '第三天',
            'focus': false,
            'date': yearthird.getFullYear() + '-' + (yearthird.getMonth() <= 8 ? '0' + (yearthird.getMonth() + 1) : yearthird.getMonth() +1 ) + '-' + (yearthird.getDate() <= 9 ? '0' + yearthird.getDate() : yearthird.getDate()),
            'value': []
          }
        ]
        this.timeObj[0].value = this.track(8)
        this.timeObj[1].value = this.track(8)
        this.timeObj[2].value = this.track(8)
      }
      else {
        this.timeObj = [
          {
            'name': '今天',
            'focus': true,
            'date': yeartoday.getFullYear() + '-' + (yeartoday.getMonth() <= 8 ? '0' + (yeartoday.getMonth() + 1) : yeartoday.getMonth() +1 )  + '-' + (yeartoday.getDate() <= 9 ? '0' + yeartoday.getDate() : yeartoday.getDate()),
            'value': []
          },
          {
            'name': '明天',
            'focus': false,
            'date': yeartom.getFullYear() + '-' + (yeartom.getMonth() <= 8 ? '0' + (yeartom.getMonth() + 1) : yeartom.getMonth() +1 ) + '-' + (yeartom.getDate() <= 9 ? '0' + yeartom.getDate() : yeartom.getDate()),
            'value': []
          },
          {
            'name': '后天',
            'focus': false,
            'date': yearsec.getFullYear() + '-' + (yearsec.getMonth() <= 8 ? '0' + (yearsec.getMonth() + 1) : yearsec.getMonth() +1 ) + '-' + (yearsec.getDate() <= 9 ? '0' + yearsec.getDate() : yearsec.getDate()),
            'value': []
          }
        ]
        this.timeObj[0].value = this.track(nextHour)
        this.timeObj[1].value = this.track(8)
        this.timeObj[2].value = this.track(8)
      }
      this.columns = this.timeObj[0].value
    },
    chooseItem(item) {
      this.timeObj.forEach((xtem) => {
        if (xtem.name === item.name) {
          xtem.focus = true
          this.columns = item.value
        }
        else {
          xtem.focus = false
        }
      })
    },
    track(start) {
      let end = 17
      let arr = []
      for (let i = start; i < end; i++) {
        arr.push({
          start: (i <= 9 ? '0' + i : i) + ':00',
          end: (i + 1 <= 9 ? '0' + (i + 1) : i + 1) + ':00'
        })
      }
      let newarr = []
      arr.forEach((item) => {
        newarr.push(item.start + ' - ' + item.end)
      })
      return newarr
    },
    getTimeSelect() {
      this.show = true
    },
    setSend(obj) {
      this.send.province = obj.province
      this.send.city = obj.city
      this.send.county = obj.county
      this.send.address_id = obj.address_id
      this.send.adrdetail = obj.adrdetail
      this.send.username = obj.username
      this.send.telephone = obj.telephone
    },
    setGet(obj) {
      this.get.province = obj.province
      this.get.city = obj.city
      this.get.county = obj.county
      this.get.address_id = obj.address_id
      this.get.adrdetail = obj.adrdetail
      this.get.username = obj.username
      this.get.telephone = obj.telephone
    },
    clearAll() {
      this.send.province = ''
      this.send.city = ''
      this.send.county = ''
      this.send.address_id = ''
      this.send.adrdetail = ''
      this.send.username = ''
      this.send.telephone = ''
      this.get.province = ''
      this.get.city = ''
      this.get.county = ''
      this.get.address_id = ''
      this.get.adrdetail = ''
      this.get.username = ''
      this.get.telephone = ''
      this.subdata.depositumInfo = '文件'
      this.subdata.depositnumNo = 1
      this.subdata.remark = ''
      this.subdata.sendStartTime = ''
      this.subdata.shipping_fee = ''
    },
    subOrder() {
      if (! this.send.telephone ) {
        Toast('请添加寄件人信息')
        return
      }
      if (! this.get.telephone ) {
        Toast('请添加收件人信息')
        return
      }
      if (this.subdata.depositnumNo <= 0) {
        Toast('托寄物数量必须大于1')
        return
      }
      if (!this.subdata.depositumInfo) {
        Toast('请填写托寄物内容')
        return
      }
      if (!this.subdata.sendStartTime) {
        Toast('请选择上门取件时间')
        return
      }
      this.$refs.myfooter.setLoading()
      this.subdata.jContact = this.send.username
      this.subdata.jMobile = this.send.telephone
      this.subdata.jProvince = this.send.province
      this.subdata.jCity = this.send.city
      this.subdata.jAddress = this.send.adrdetail
      this.subdata.dContact = this.get.username
      this.subdata.dMobile = this.get.telephone
      this.subdata.dProvince = this.get.province
      this.subdata.dAddress = this.get.adrdetail
      this.subdata.dCity = this.get.city
      addSf({
        ...this.subdata
      }).then((res) => {
        this.$refs.myfooter.closeLoading()
        if (res.data.status_code === 200) {
          Toast('新增成功')
          this.$router.push({ path: '/sf/expressdetail', query: { sf_order_id: res.data.order.sf_order_id, add_new: 1 }})
        }
      })
    },
    jumpList(type) {
      let address_id = ''
      if (type === 'send') {
        address_id = this.send.address_id
      }
      if (type === 'get') {
        address_id = this.get.address_id
      }
      this.$router.push({
        path: '/sf/addresslist',
        query: { type: type, address_id: address_id }
      })
    }
  }
}
</script>
<style lang="less">
  .couponspecon{
    width:100%;
    height:100%;
    background-color:#ffffff;
  }
  .expresspopup{
    .van-picker__toolbar{
      display:none;
    }
  }
  .van-ellipsis{
    font-size:32px;
  }
  .myvanfield{
    .van-field__label{
      width:400px;
    }
    .red{
      color:#E60012;
    }
  }
  .myvancell{
    border-radius:15px;
    margin-bottom:16px;
    .van-icon-arrow{
      font-size:34px;
      margin-top:20px;
    }
  }
</style>
<style lang="less" scoped>
  .addexpress{
    min-height:100vh;
    background-color: #f4f5fb;
    .con{
      margin:0px 15px;
      .sendget{
        width:100%;
        min-height: 143px;
        background: #FFFFFF;
        border-radius: 20px;
        border: 0px solid #F099BA;
        margin-bottom:30px;
        display:flex;
        .left{
          width:20%;
          display:flex;
          align-items: center;
        }
        .center{
          flex:1;
          .title{
            font-weight: 400;
            font-size: 30px;
            color: #444444;
            line-height: 31px;
            padding-top:15px;
            margin-bottom:15px;
          }
          .address{
            font-weight: 400;
            font-size: 24px;
            color: #999999;
            line-height: 31px;
            padding-bottom:10px;
          }
        }
        .right{
          width:10%;
          display:flex;
          align-items: center;
          .arrow{
            color:#A9A9A9;
            font-size:50px;
            margin:0px auto;
          }
        }
      }
      .send{
        margin-bottom:12px;
        .round{
          width:50px;
          height:50px;
          margin:0px auto;
          border-radius: 25px;
          background-color:#000000;
          font-weight: 400;
          font-size: 30px;
          color: #FCFCFC;
          line-height: 49px;
          text-align:center;
        }
      }
      .get{
        .round{
          width:50px;
          height:50px;
          margin:0px auto;
          border-radius: 25px;
          background-color:#E60012;
          font-weight: 400;
          font-size: 30px;
          color: #FCFCFC;
          line-height: 49px;
          text-align:center;
        }
      }
      .myvanfield{
        margin-bottom:13px;
      }
      .des{
        font-weight: 400;
        font-size: 24px;
        color: #E60012;
        text-align:center;
      }
    }
    .popcon{
      height:100%;
      .h2{
        height:28px;
        font-weight: 400;
        font-size: 22px;
        color: #aeaeae;
        line-height: 28px;
        padding-left:20px;
        margin-bottom:20px;
      }
      .h1{
        text-align:right;
        height:36px;
        padding-top:20px;
        margin-bottom:20px;
        span{
          font-weight: 400;
          font-size: 24px;
          color: #414141;
          line-height: 36px;
          margin-right:20px;
          float:right
        }
        .myspan1{
          float:left;
          padding-left:20px;
        }
      }
      .timecon{
        width:100%;
        height:85%;
        display:flex;
        .left{
          width:262px;
          background: #ffffff;
          box-shadow: 0px 0px 47px 2px rgba(5,5,5,0.06);
          padding-top:50px;
          .item{
            width: 129px;
            height: 82px;
            font-size:30px;
            line-height:82px;
            text-align:center;
            margin:0px auto 50px auto;
          }
          .focus{
            background: #FFFFFF;
            box-shadow: 0px 0px 122px 0px rgba(5,5,5,0.13);
            border-radius: 10px;
            border: 0px solid #F099BA;
          }
        }
        .right{
          width:488px;
          background: #ffffff;
          box-shadow: 0px 0px 47px 2px rgba(5,5,5,0.06);

        }
      }
    }
    .waitpay{
      font-weight: 400;
      font-size: 24px;
      color: #FFFFFF;
      width: 493px;
      height: 48px;
      background: #E60012;
      border-radius: 24px;
      border: 3px solid #FF9C9C;
      padding-left:20px;
      line-height:48px;
      margin-left:14px;
      position:absolute;
      bottom:200px;
    }
  }
</style>
